// Where the marketing site sends people, depending on whether they're signed in.

import store from "../../store/store";
import { safeNextPath } from "../errors/apiError";

export const SIGNUP_PATH = "/auth/register";
export const PRACTISE_PATH = "/c/practise";
export const PLAN_PATH = "/c/you/plan";
export const ONBOARDING_PATH = "/c/profile-completion";

export const isSignedIn = () => Boolean(store.getState().login?.isAuthenticated);

// Firm pages: the public guides signed out, the app's firm page signed in.
export const FIRM_PATHS = ["/firms/:firmSlug", "/firms/:firmSlug/:roleSlug/interview-guide"];

// A sign-up button. Signed in, it opens Practise instead; a plan button
// opens the plan page and keeps its label.
export function signupCta(label, { plan = false, signedIn = isSignedIn() } = {}) {
  if (!signedIn) return { label, href: SIGNUP_PATH };
  return plan ? { label, href: PLAN_PATH } : { label: "Practise now", href: PRACTISE_PATH };
}

// After sign-up or sign-in: a new account goes through onboarding, which
// hands off to `next` when it's done (see saveAfterSignup). Otherwise
// `next`, else Practise. The app still sends unfinished accounts to onboarding.
export function afterAuthPath({ next, newAccount = false } = {}) {
  if (newAccount) return ONBOARDING_PATH;
  return safeNextPath(next) || PRACTISE_PATH;
}
